import { STORAGE_KEYS } from '@/modules/home/constant';
import { toast } from '@/utils/useToast';

export const handleResponseError = async (error) => {
    console.log("handle error   ", error);

    // If there's no error message, assume it's a network error.
    if (!error.message) {
        console.error("Network error:", error);
        toast.error("Network error. Please check your connection.");
        return Promise.reject(error);
    }

    // Check if error.response exists
    if (!error.response) {
        console.error("No response from server:", error);
        toast.error(error.message || "No response from server. Please try again later.");
        return Promise.reject(error);
    }

    // Now that we know error.response exists, destructure status and data
    const { status, data } = error.response;

    if (status === 400) {
        if (Array.isArray(data.errors)) {
            data.errors.forEach((err) => {
                toast.error(err.message || err);
            });
        } else if (data?.message) {
            toast.error(data.message);
        } else {
            toast.error("Bad request. Please check your input.");
        }
    } else if (status === 429) {
        toast.error(data.error || "Too many requests. Please try again later.");
    } else if (data?.code) {
        switch (data.code) {
            case "INVALID_CREDENTIALS":
                toast.error("Invalid email or password.");
                break;
            case "USER_NOT_FOUND":
                toast.error("User does not exist.");
                break;
            case "ACCOUNT_LOCKED":
                toast.error("Your account is locked. Please contact support.");
                break;
            default:
                toast.error(data.message || "An error occurred.");
        }
    } else {
        switch (status) {
            case 401:
                toast.error("Unauthorized. Redirecting to login...");
                localStorage.removeItem(STORAGE_KEYS.LOCAL_STORAGE);
                if (window.location.pathname !== "/auth/login") {
                    setTimeout(() => {
                        window.location.href = "/auth/login";
                    }, 2000);
                }
                break;
            case 403:
                toast.error(data.message || "Forbidden");
                break;
            case 404:
                toast.error(data.message || "Resource not found");
                break;
            case 500:
                toast.error(data.message || "Internal Server Error");
                break;
            default:
                toast.error(data.message || "An unexpected error occurred.");
        }
    }

    return Promise.reject(error.response?.data || error);
};
